export default __webpack_public_path__ + "static/media/1894.d10e0f7f.png";